@if (initialized && interactionData && interactionData.type) {

  <schedule-appointment-type
    [scheduleTypes]="interactionData.type.scheduleTypes"
    [appointmentTypeId]="interactionData.type.appointmentTypeId"
    [(selectedType)]="selectedScheduleType"
    (selectedTypeChange)="handleSelectedTypeChange($event)"
    (onSelectBookingPeriod)="handleSelectBookingPeriod($event)"
  ></schedule-appointment-type>

  @if (bookingPeriod && selectedScheduleType?.scheduleTypeInternal == ScheduleTypeInternal.bookings) {
<!--    <hr class="mt-8">-->
<div class="relative">

    <app-button [busy]="busy"
                class="absolute"
                style="right: 130px; top: -40px"
                [disabled]="busy"
                [label]="'Absenden'"
                [iconPos]="'right'"
                [showIcon]="true"
                [icon]="'pi pi-arrow-right'"
                (onClick)="handleEvent('finalize')">
    </app-button>
  </div>
  }
}
